export * from './phone-type-api.service';
export * from './phone-type-api.interface';
